/**
 * Created by Mikhail Menshenin on 20.08.2024
 */

MenuBar.listItems = function () {
    const items = [];

    if (cleverapps.config.name === "yatzy") {
        items.push(cleverapps.MenuBarItems.GoldItem);
        if (cleverapps.config.features.includes("lives")) {
            items.push(cleverapps.MenuBarItems.LivesItem);
        }
        items.push(cleverapps.MenuBarItems.CoinsItem);

        return items;
    }

    items.push(cleverapps.MenuBarItems.GoldItem);

    if (cleverapps.config.features.includes("lives")) {
        items.push(cleverapps.MenuBarItems.LivesItem);
    }

    if (cleverapps.config.soft) {
        items.push(cleverapps.MenuBarItems.CoinsItem);
    }

    if (typeof OrderStarsMenuBarItem !== "undefined") {
        items.push(OrderStarsMenuBarItem);
    }

    return items;
};

cleverapps.MenuBarItems = {};
cleverapps.MenuBarItems.GoldItem = {
    name: "GoldItem",
    isClickable: function () {
        return cleverapps.flags.monetization !== cleverapps.Flags.MONETIZATION_DISABLED;
    },
    clickableUpdater: function (f) {
        cleverapps.flags.on("change:monetization", f, this);
    },
    targets: "hard",
    plusButton: true,
    value: function () {
        return cleverapps.user.gold - cleverapps.pendingRewards.get("hard");
    },
    updater: function (f) {
        cleverapps.user.on("changeHard", f, this);
    },
    attentionUpdater: function (f) {
        cleverapps.adsLimits.on("update", f, this);

        if (cleverapps.subscription) {
            cleverapps.subscription.on("update", f, this);
        }
    },
    sparks: true,
    attention: function () {
        if (ShopProductSource.listProducts(ShopWindow.TABS.HARD_CURRENCY).indexOf("hardForVideo") !== -1
            && cleverapps.adsLimits.state(AdsLimits.TYPES.HARD) === AdsLimits.STATE_READY) {
            return true;
        }
        if (ShopProductSource.listProducts(ShopWindow.TABS.HARD_CURRENCY).indexOf("subsMonth") !== -1
            && cleverapps.subscription && cleverapps.subscription.needsAttention()) {
            return true;
        }
        return false;
    },
    availableOnScenes: function () {
        const scenes = [
            cleverapps.Environment.SCENE_MAIN,
            cleverapps.Environment.SCENE_GAME
        ];
        return scenes;
    },
    icon: bundles.menubar.frames.gold_png,
    onClickWindow: () => HardCurrencyShopWindow,
    decEffect: "meta.coins.collect",
    onDebugClick: function () {
        cleverapps.user.earnHard(cleverapps.EVENTS.EARN.OTHER, 1000);
    }
};

if (cleverapps.config.features.includes("lives")) {
    cleverapps.MenuBarItems.LivesItem = {
        name: "LivesItem",
        targets: "lives",
        plusButton: true,
        attentionUpdater: function (f) {
            if (Game.currentGame && Game.currentGame.energyLottery) {
                Game.currentGame.energyLottery.onLotteryAttentionChanged = f;
            }
        },
        attention: function () {
            if (Game.currentGame && Game.currentGame.energyLottery) {
                return Game.currentGame.energyLottery.isReady();
            }
        },
        availableOnScenes: function () {
            return [
                cleverapps.Environment.SCENE_MAIN
            ];
        },
        force: Forces.BUY_ENERGY_ICON,
        viewClass: MenuBarWithTimeoutView,
        modelClass: LivesMenuBarItemModel,
        icon: function () {
            return cleverapps.skins.getSlot("menubar_life_png") || bundles.menubar.frames.menubar_life_png;
        },
        onClickWindow: () => LivesShopWindow,
        filter: function () {
            if (cleverapps.unlimitedLives && cleverapps.unlimitedLives.freeOfferIsAvailable()) {
                cleverapps.unlimitedLives.showFreeOffer(() => { });
                return false;
            }

            if (cleverapps.unlimitedLives && cleverapps.unlimitedLives.checkBuyed() || connector.platform.oneOf(connector.DIGITAL)) {
                return false;
            }
            return true;
        },
        sparks: true,
        incEffect: "menubar.lives.fly_finish",
        decEffect: "menubar.lives.fly_finish",
        onDebugClick: function () {
            cleverapps.lives.setAmount(cleverapps.lives.getMaxLives());
        }
    };
}

cleverapps.MenuBarItems.CoinsItem = {
    name: "CoinsItem",
    targets: "soft",
    plusButton: true,
    value: function () {
        return cleverapps.user.soft - cleverapps.pendingRewards.get("soft");
    },
    updater: function (f) {
        cleverapps.user.on("changeSoft", f, this);
    },
    attentionUpdater: function (f) {
        cleverapps.adsLimits.on("update", f, this);
    },
    attention: function () {
        return false;
    },
    onClickWindow: () => SoftCurrencyShopWindow,
    icon: bundles.menubar.frames.coin_png,
    force: Forces.MENU_BAR_SOFT_FORCE,
    availableOnScenes: function () {
        return [
            cleverapps.Environment.SCENE_MAIN,
            cleverapps.Environment.SCENE_GAME
        ];
    },
    sparks: true,
    decEffect: "meta.coins.collect",
    onDebugClick: function () {
        cleverapps.user.setSoft(cleverapps.user.soft + 100, false, { event: cleverapps.EVENTS.EARN.OTHER });
    }
};